import { DESKTOP_PATH, MY_COMPUTER_PATH, MY_DOCUMENTS_PATH, MY_PICTURES_PATH } from './filesystem';
import type { AppArgs } from '@/wm/types';

export interface StartMenuEntry {
  label: string;
  icon: string;
  /** App to launch when clicked. */
  appId: string;
  args?: AppArgs;
  /** Draw a separator line above this entry. */
  separatorBefore?: boolean;
  /** Rendered in the smaller, secondary style XP used lower in the right column. */
  small?: boolean;
}

/**
 * Apps shown in the pinned (top-left) area, in order. XP shipped with exactly
 * two above the rule — a browser and a mail client — and everything else
 * arrived there by being used.
 */
export const pinnedAppIds: string[] = ['ie', 'outlook'];

/** The blue right-hand column. */
export const rightColumn: StartMenuEntry[] = [
  {
    label: 'My Documents',
    icon: '/assets/icons/my-documents.svg',
    appId: 'explorer',
    args: { path: MY_DOCUMENTS_PATH },
  },
  {
    label: 'My Pictures',
    icon: '/assets/icons/my-pictures.svg',
    appId: 'explorer',
    args: { path: MY_PICTURES_PATH },
  },
  {
    label: 'My Computer',
    icon: '/assets/icons/my-computer.svg',
    appId: 'explorer',
    args: { path: MY_COMPUTER_PATH },
  },
  {
    label: 'Desktop',
    icon: '/assets/icons/folder.svg',
    appId: 'explorer',
    args: { path: DESKTOP_PATH },
  },
  {
    label: 'Control Panel',
    icon: '/assets/icons/control-panel.svg',
    appId: 'display',
    separatorBefore: true,
    small: true,
  },
  {
    label: 'Help and Support',
    icon: '/assets/icons/help.svg',
    appId: 'ie',
    args: { url: 'about:help' },
    small: true,
  },
  {
    label: 'Run...',
    icon: '/assets/icons/run.svg',
    appId: 'run',
    small: true,
  },
];
